/* eslint-disable */
import ApiService from '@/services/Base/ApiService';

const getDefaultState = () => {
  return {
    results: null,
    uiResults: null,

    savedUiDetails: {},

    isOpenedHgFarmerDetail: false,
    
    openedHgFarmerDetail: { id: 0, },
    openedHgFarmerDetails: {},
  }
}

const state = getDefaultState()

const getters = {
  getResults(state) {
    return state.results;
  },
  getUiResults(state) {
    return state.uiResults;
  },
}

const mutations = {
  setResults(state, data) {
    state.results = data;
  },
  setUiResults(state, data) {
    state.uiResults = data;
  },
}

const actions = {
  async fetchHgFarmerDetails(context, groupedSourceCodes) {
    try {
      if (!groupedSourceCodes) {
        return;
      }
      const saveDetail = context.state.savedUiDetails[groupedSourceCodes.join(',')]
      if (saveDetail) {
        return saveDetail;
      } else {
        const response = await ApiService.get('HgFarmerDetail');
        if (response.statusCode === 200) {
          const filtered = response.result.filter(x => groupedSourceCodes.includes(x.sourceCode));
          context.state.savedUiDetails[groupedSourceCodes.join(',')] = filtered;
          return filtered;
        } else {
          throw error;
        }
      }
      
    } catch (error) {
      throw error;
    }
  },

  async fetchHgFarmerDetail(context, id) {
    try {
      const response = await ApiService.get(`HgFarmerDetail/${id}`);
      if (response.statusCode === 200) {
        context.state.openedHgFarmerDetail = response.result;
        return response.result;
      } else {
        throw error;
      }
      
    } catch (error) {
      throw error;
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
